import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  categoryPaper: {
    position: 'relative',
    overflow: 'hidden',
    height: 400,
    cursor: 'pointer',
    background: '#F7F7F7 !important',
    '&:after': {
      top: 0,
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      bottom: 0,
      opacity: .75,
      backgroundImage: 'linear-gradient(to bottom, rgba(11, 11, 11, 0) 80%, #080808)'
    }
  },
  categoryImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  categoryLabel: {
    fontWeight: 500,
    fontSize: 20,
    textAlign: 'center',
    width: '100%',
    color: theme.palette.common.white,
    position: 'absolute',
    textShadow: '0px 1px 3px rgba(0, 0, 0, .5)',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    bottom: 0,
    zIndex: 1,
  },
}));
